module.exports = __webpack_public_path__ + "img/7C.d2e8a6b9.svg";